// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3I1D_","rootCenter":"LoadMoreObserver_rootCenter__2DKrg","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1Es5n"};